import { Question } from '../../question.class';
import { TableHandler } from './table';
import { getPropertyDescriptor } from '../../../../functions';
import { mapValues } from 'lodash';

declare module '../../question.class' {
  interface Question {
    table: TableHandler;
  }
}

const type = 'table-checkbox';

let QuestionValue = getPropertyDescriptor(Question.prototype, 'value');
Object.defineProperty(Question.prototype, 'value', {
  get: function(): boolean {
    if (this.type === type) {
      // 1. add table property into value
      // 2. override options to include text-empty options
      return {
        ...QuestionValue.get.apply(this),
        table: this.get(['table']),
        options: mapValues(this._options, o => o.value)
      };
    } else {
      return QuestionValue.get.apply(this);
    }
  }
});
let QuestionInit = Question.prototype.init;
Question.prototype.init = function(...args) {
  if (args[0] === type) {
    this.table = new TableHandler(this, ['table']);
    if (!this.table.value) {
      // if table not set, set the default value
      (<TableHandler>this.table).set('showXHeader', true, { push: 'none' });
      (<TableHandler>this.table).set('showYHeader', true, { push: 'none' });
      (<TableHandler>this.table).xLength = 6;
      (<TableHandler>this.table).yLength = 7;
    }
    QuestionInit.apply(this, args);
  } else {
    QuestionInit.apply(this, args);
  }
};

let QuestionOnComposeInit = Question.prototype.onComposeInit;
Question.prototype.onComposeInit = function(...args) {
  if (args[0] === type) {
    (<Question>this).deleteOptions(undefined);
    (<Question>this)
      .getDecendantQuestions()
      .forEach(q => q.survey.deleteQuestions({ id: q.id }));
    (<Question>this).set('canHaveQuotaOptions', true);
    this.table = new TableHandler(this, ['table']);
    (<TableHandler>this.table).set('showXHeader', true, { push: 'none' });
    (<TableHandler>this.table).set('showYHeader', true, { push: 'none' });
    (<TableHandler>this.table).xLength = 6;
    (<TableHandler>this.table).yLength = 7;
    this.max_checked_option_cnt = 1;
    QuestionOnComposeInit.apply(this, args);
  } else {
    QuestionOnComposeInit.apply(this, args);
  }
};
let QuestionOnComposeDestroy = Question.prototype.onComposeDestroy;
Question.prototype.onComposeDestroy = function(...args) {
  if (args[0] === type) {
    if (this.table) (<Question>this).table.destroy();
    (<Question>this).deleteOptions(undefined);
    delete (<Question>this).table;
    this.max_checked_option_cnt = undefined;
    QuestionOnComposeDestroy.apply(this, args);
  } else {
    QuestionOnComposeDestroy.apply(this, args);
  }
};

console.log("question type table-checkbox is added");